export const SET_APPROVAL_PAGE_TYPE = 'SET_APPROVAL_PAGE_TYPE';
export const SET_APPROVAL_REQUEST_DATA = 'SET_APPROVAL_REQUEST_DATA';
export const SET_COMMENTS = 'SET_COMMENTS';

export const SET_APPROVAL_TYPE ='SET_APPROVAL_TYPE';
export const SET_APPROVAL_STATUS ='SET_APPROVAL_STATUS';
export interface setApprovalPageType {
    type: typeof SET_APPROVAL_PAGE_TYPE;
    payload: any
};

export interface setApprovalRequestData {
    type: typeof SET_APPROVAL_REQUEST_DATA;
    payload: any
}; 
export interface setComments {
    type: typeof SET_COMMENTS;
    payload: any
};
export interface setApprovalType {
    type:typeof SET_APPROVAL_TYPE;
    payload: any;
};
export interface setApprovalStatus {
    type:typeof SET_APPROVAL_STATUS;
    payload: any;
};

export type approvalType = setApprovalPageType | setApprovalRequestData | setComments | setApprovalType | setApprovalStatus;
